<p class="caption status-danger mt-1">
  <ng-container *ngIf="control.invalid && control.touched" class="summary-content">
    <span *ngIf="control.errors?.required || control.errors?.isRequired ">El campo es requerido</span>
    <span *ngIf="control.errors?.minlength">El campo debe tener un minimo de {{control.errors?.minlength.requiredLength}} caracteres</span>
    <span *ngIf="control.errors?.maxlength">El campo puede tener un maximo de {{control.errors?.maxlength.requiredLength}} caracteres</span>
    <span *ngIf="control.errors?.min">El campo debe tener un mínimo de {{control.errors?.min.min}}</span>
    <span *ngIf="control.errors?.max">El campo debe tener un máximo de {{control.errors?.max.max}}</span>
    <span *ngIf="control.errors?.pattern">El campo tiene un formato invalido</span>
    <span *ngIf="control.errors?.email">El email tiene un formato invalido</span>
    <span *ngIf="control.errors?.atLeastOne">Introduzca al menos un valor</span>
    <span *ngIf="control.errors?.invalidDate">Fecha invalida (DD/MM/YYYY)</span>
    <span *ngIf="control.errors?.invalidDateAfterNow">Fecha invalida (No puede ser mayor a hoy)</span>
    <span *ngIf="control.errors?.invalidDateMin">Fecha invalida (No puede ser menor a 1900)</span>
    <span *ngIf="control.errors?.backend">{{ control.errors?.backend }}</span>
    <span *ngIf="control.parent?.get('type')?.value">Ingrese un numero valido</span>
  </ng-container>
</p>
